import { FC } from "react";
import PageTemplate from "../PageTemplate";
import NotFoundPage from "./NotFoundPage";

const NotFound: FC = () => {
    return <PageTemplate Page={NotFoundPage} noBreadcrumbs />;
};

export default NotFound;
